import { useContext } from "react";
import STBoardComments from "../../../assets/styles/organisms/boardComment.module.scss";
import STBoard from "../../../assets/styles/organisms/boardForm.module.scss";
import { Link } from "@material-ui/core";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { SiteContext } from "../../../providers/SiteProvider";

const CommentsHeader = () => {
  const {
    state: { totalComments },
  } = useBoard();
  const site = useContext(SiteContext);
  return (
    <div className={STBoardComments.commentHeader}>
      <p className={STBoardComments.commentHeaderTitle}>{`コメント${
        totalComments ? ":" : ""
      }`}</p>
      {!!totalComments && (
        <p className={STBoardComments.commentHeaderTotalComments}>
          {`${totalComments} 件のコメントがあります`}
        </p>
      )}
      {site.forumGuideUrl && (
        <Link
          href={site.forumGuideUrl}
          className={`${STBoard.guideLink} ${STBoard.commentHeaderGuideLink}`}
          style={{ fontSize: "12px" }}
          target="_blank"
        >
          {site.forumGuideText}
          <span className={STBoard.arrowRight}>
            <span> </span>
            {">"}
          </span>
        </Link>
      )}
    </div>
  );
};

export default CommentsHeader;
